import { render } from "./legal.vue?vue&type=template&id=0a2cf439&scoped=true"
import script from "./legal.vue?vue&type=script&lang=js"
export * from "./legal.vue?vue&type=script&lang=js"

import "./legal.vue?vue&type=style&index=0&id=0a2cf439&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2cf439"]])

export default __exports__